<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
            <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Data Entry</h6>
                </div>
            </div>

            <div class="card p-2">
                <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 lg:space-x-4">
                    <div class="w-full lg:w-auto">
                        <label for="orderDate" class="block text-sm font-medium text-gray-700">Order Date</label>
                        <input
                            type="date"
                            id="orderDate"
                            v-model="filter.orderDate"
                            class="w-full p-2 border border-gray-300 rounded"
                        />
                    </div>

                    <div class="w-full lg:w-auto flex justify-center lg:justify-start">
                        <button
                            type="button"
                            @click="getFilterOrders"
                            class="btn btn-primary-solid px-5 mt-2 ml-4 mb-2 lg:mt-5 lg:ml-3 w-full lg:w-auto cursor-pointer"
                        >
                            Filter
                        </button>
                    </div>
                </div>
            </div>

            <div class="p-3 sm:p-4">
                <div class="flex flex-wrap items-end gap-4 mb-4">
                    <div class="w-full sm:w-64">
                        <label for="orderStatus" class="form-label">Status *</label>
                        <select id="orderStatus" v-model="entry.status" class="form-input">
                            <option value="">Select Status</option>
                            <option v-for="status in statuses" :key="status" :value="status">
                                {{ status }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="overflow-x-auto scrollbar-table">
                    <table class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none datatable table-bordered" id="dataEntryTable">
                        <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                            <tr>
                                <th class="px-3.5 py-4">Date</th>
                                <th class="px-3.5 py-4">Order Number</th>
                                <th class="px-3.5 py-4">Customer Name</th>
                                <th class="px-3.5 py-4">Full Shirt</th>
                                <th class="px-3.5 py-4">Half Shirt</th>
                                <th class="px-3.5 py-4">Pant</th>
                                <th class="px-3.5 py-4">Status</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                            <tr
                                class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white"
                                v-for="item in orderList"
                                :key="item.id || item.order_number"
                            >
                                <td class="px-3.5 py-4">{{ item.order_date || item.date }}</td>
                                <td class="px-3.5 py-4">{{ item.order_number }}</td>
                                <td class="px-3.5 py-4">{{ item.customer_name }}</td>
                                <td class="px-3.5 py-4">
                                    <input :readonly="item.full_shirt<=0" class="qty_input" v-model="item.entered_qty_full" type="number" @input="validate(item)"> {{ item.original_full_shirt}}
                                    <span>{{item.status_full_shirt}} {{item.status}}</span>    
                                </td>
                                <td class="px-3.5 py-4"><input :readonly="item.half_shirt<=0" class="qty_input" v-model="item.entered_qty_half" type="number" @input="validate(item)">{{ item.original_half_shirt }}</td>
                                <td class="px-3.5 py-4"><input :readonly="item.pant<=0" class="qty_input" v-model="item.entered_qty_pant" type="number"  @input="validate(item)">{{ item.original_pant }}</td>
                                <td>
                                    
                                        {{getStatusString(item.statuses)}}
                                    
                                </td>
                            </tr>
                            <tr v-if="orderList.length == 0">
                                <td colspan="6" class="px-3.5 py-8 text-center text-gray-400">
                                    No orders found
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="flex justify-end mt-7">
                    <button
                        type="button"
                        @click="saveDataEntry"
                        class="btn b-solid btn-primary-solid cursor-pointer shadow-sm"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- End Main Content -->
</template>

<script>
import axios from 'axios';

export default {
    name: 'DataEntry',
    mounted() {
        // this.getOrders();
    },
    data() {
        const today = new Date().toISOString().split('T')[0];

        return {
            orderList: [],
            statuses: [
                'Washing',
                'Cutting',
                'Stitching',
                'ironing',
                'packing',
                'delivered',
            ],
            filter: {
                orderDate: today,
            },
            entry: {
                orderDate: today,
                status: '',
            },
        };
    },
    methods: {
      
        async getOrders() {
            var self = this;

            axios.post('getDataEntryOrders', this.filter)
                .then(function (response) {
                    self.destroyDatatble();
                    self.orderList = response.data.orderList || [];
                })
                .catch(function (error) {
                    console.log('Error while loading orders: ' + error);
                })
                .then(function () {
                    self.$nextTick(function () {
                        self.refreshDatatble();
                    });
                });
        },
        getStatusString(statuses) {

            return statuses.map(status => {
        
                let qty = [];
        
                if (parseInt(status.full) > 0) {
                    qty.push(`F:${status.full}`);
                }
        
                if (parseInt(status.half) > 0) {
                    qty.push(`H:${status.half}`);
                }
        
                if (parseInt(status.pant) > 0) {
                    qty.push(`P:${status.pant}`);
                }
        
                return `${status.status} (${qty.join(', ')}) ${status.iddate}`;
        
            }).join(' | ');
        },
        getFilterOrders() {
            this.entry.orderDate = this.filter.orderDate;
            this.getOrders();
        },

        saveDataEntry() {
            var self = this;

            if (!this.entry.status) {
                this.$swal('Please select status');
                return;
            }

            if (this.orderList.length == 0) {
                this.$swal('No orders available to save');
                return;
            }

            const payload = {
                orderDate: this.filter.orderDate,
                status: this.entry.status,
                orders: this.orderList.map(function (item) {
                    return {
                        id: item.id,
                        order_number: item.order_number,
                        halfqty: item.entered_qty_half,
                        fullqty: item.entered_qty_full,
                        pantqty: item.entered_qty_pant,
                        custid: item.custid,
                    };
                }),
            };

            axios.post('saveDataEntry', payload)
                .then(function (response) {
                    var msg = response.data.msg || 'Data entry saved successfully';
                    var isSuccess = response.data.status;

                    self.$swal(msg);

                    if (isSuccess == 1) {
                        self.entry.status = '';
                        self.getOrders();
                    }
                })
                .catch(function (error) {
                    console.log('Error while saving data entry: ' + error);
                });
        },

        refreshDatatble() {
            if (this.orderList.length > 0) {
                this.datatable = $('.datatable').DataTable({
                    paging: true,
                    ordering: true,
                    autoWidth: false,
                });
            }
        },
        validate(item) {

                // Full shirt validation
                if (item.entered_qty_full < 0) {
                    item.entered_qty_full = 0;
                }
        
                if (item.entered_qty_full > item.original_full_shirt) {
                    item.entered_qty_full = item.original_full_shirt;
                }
        
                // Half shirt validation
                if (item.entered_qty_half < 0) {
                    item.entered_qty_half = 0;
                }
        
                if (item.entered_qty_half > item.original_half_shirt) {
                    item.entered_qty_half = item.original_half_shirt;
                }
        
                // Pant validation
                if (item.entered_qty_pant < 0) {
                    item.entered_qty_pant = 0;
                }
        
                if (item.entered_qty_pant > item.original_pant) {
                    item.entered_qty_pant = item.original_pant;
                }
            },

        destroyDatatble() {
            if ($.fn.dataTable.isDataTable('.datatable')) {
                $('.datatable').DataTable().destroy();
            }
        },
    },
};
</script>
<style scoped>
    .qty_input{
        border: 1px solid black;
        width: 50px;
        padding: 4px;
        margin-right: 5px;
        border-radius: 3px;
    }
</style>